import { render, staticRenderFns } from "./MagazzinoScadenziarioListComponent.vue?vue&type=template&id=ddf169c4"
import script from "./MagazzinoScadenziarioListComponent.vue?vue&type=script&lang=js"
export * from "./MagazzinoScadenziarioListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports